import React, { useEffect, useRef, useState } from "react";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import DropSelect from "../modules/AutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import verified from "../../Assets/svg/verified.svg";
import cross from "../../Assets/svg/cross.svg";
import { addTokenInfo } from "../LoginPage/redux/actions";
import GradientLoader from "../modules/Loader";
import Button from "../modules/Button";
import StaticItem from "../modules/StaticItem";
import { Occupations } from "../modules/CollegeList";
import ModalComponent from "../modules/Modal";
import { addPanList, setDateList } from "./redux/actions";
import StaticField from "../StaticField";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
function EarningMemberInfo(props) {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.status.statusData);
  const [err, showErr] = useState(false);
  const [isDate, setDate] = useState("");
  const [panErr, setPanErr] = useState("");
  const [warning, setWarning] = useState(null);
  const [isLoader, showLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [panverified, isPan] = useState(false);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [incomeList, setIncomeList] = useState({
    Father: "fatherIncomeCertificate",
    Mother: "motherIncomeCertificate",
    Sibling1: "sibling1IncomeCertificate",
    Sibling2: "sibling2IncomeCertificate",
    Sibling3: "sibling3IncomeCertificate",
    Guardian: "guardianIncomeCertificate",
    Myself: "incomeCertificate",
    "No-one": "noIncomeCertificate",
  });  
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const panList = useSelector((state) => state.income.panList);
  const dateList = useSelector((state) => state.income.dateList);

  const [uploading, setUploading] = useState(false);
  const [doc, setDoc] = useState(null);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const getValidDate = (date) => {
    if (date?.split("-")[2]?.length > 2) {
      date = date?.split("-")?.reverse()?.join("-");
    } else if (!date?.split("-")[1]) {
      date = `${date}-01-01`;
    }
    return date;
  };
  const submitPan = async (value) => {
    try {
      let res = await checkPan(value);
      let pL = { ...panList };
      if (res?.data?.panStatusCode === "E") {
        // setTimeout(()=>)
        setWarning(true);
        pL[props?.item?.relationShipType] = true;
        dispatch(addPanList({ ...pL }));

        setPanErr("");
      } else {
        setWarning(false);
        pL[props?.item?.relationShipType] = false;
        dispatch(addPanList({ ...pL }));

        setPanErr("Incorrect Pan Number");
        setTimeout(() => setPanErr(""), 3000);
      }
      return res;
    } catch (error) {
      console.error("Error Validating PAN:", error);
    }
  };
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      props.showModal("File with double extensions is not allowed.");

      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const filterData = (type, value) => {
    if (type === "firstName") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (type === "income") {
      value = value.replace(/\D/g, "");
      if (value < 1) {
        value = "";
      }
    } else if (type === "mobile") {
      value = value.replace(/\D/g, "");
      // if (value.length > 9) {
      value = value.slice(0, 10);
      // }
    } else if (type === "pan") {
      value = value.slice(0, 10);
      let first = value.slice(0, 5);
      let second = value.slice(5, 9);
      let third = value.slice(9);
      first = first.replace(/[^a-zA-Z\s]/g, "");
      second = second.replace(/\D/g, "");
      third = third.replace(/[^a-zA-Z\s]/g, "");
      value = first + second + third;
      // if (value.length === 10) {
      //   setTimeout(() => submitPan(value), 200);
      // }
      // console.log("in enter", value);
    } else if (type === "dob") {
      // const enteredDate = new Date(value);
      // const currentDate = new Date();
      // if (enteredDate === currentDate || enteredDate > currentDate) {
      //   alert("Please select a date that is not in the future.");
      //   value = "";
      // }
      // console.log("date set here", value);
      setDate(value);
      // value = formatDate(value);
      // value = value.split("-").reverse().join("-");
    } else if (type === "doc" && value !== null) {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "application/msword",
        ".doc",
        ".docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      let isFormat = false;
      for (let i in allowedTypes) {
        if (value.type === allowedTypes[i]) {
          isFormat = true;
        }
      }
      if (!isFormat) {
        alert("Only PDF, JPEG, PNG, and Word files are allowed.");
        setDoc(null); // Clear the file input
        value = null;
      } else if (value.size / 1024 / 1024 > 2) {
        value = null;
        showErr(true);
        // setTimeout(() => showErr(false), 3000);
      } else {
        // const file = event.target.files[0];

        if (value && !allowedTypes?.includes(value.type)) {
          setErrorMessage("Only PDF, JPEG, PNG, and Word files are allowed.");
          value = null; // Clear the file input
        } else {
          setErrorMessage("");
          // Handle file upload logic here
        }
      }
      value = validateFileName(value);
    }
    return value;
  };

  const checkPan = async (value) => {
    const name = props.item?.firstName;
    const dob = getValidDate(props.item?.dob);
    try {
      let panInfo = { panNumber: props?.item?.pan, name: name, dob: dob };
      const users = await api.verifyPan(panInfo, tokenData.token);
      return users;
    } catch (error) {
      console.error("Error invoking pan verification:", error);
      // Handle error scenario
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    // console.log()
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    // console.log("dateString",day, month, year)
    return `${day}-${month}-${year}`;
    // return day
  }
  const onClickhandler = (type, value) => {
    value = filterData(type, value);

    if (type === "income") {
      if (value < 600001) {
        props.addData(props?.item?.relationShipType, type, value);
      } else {
        alert("Annual income should not exceed 600000");
      }
      // } else if (type === "dob") {
    } else {
      props.addData(props?.item?.relationShipType, type, value);
    }
    // if (value.length === 10) {
    //   setTimeout(() => submitPan(value), 200);
    // }
    // props.addData(props?.item?.relationShipType, type, value);
  };
  const toolTipData = () => {
    return (
      <div className="tool-tip-div">
        <div className="tool-tip-title">Proof of Income</div>
        <div className="ul-div">
          Upload any one of the following: Salary Slip Income Certificate
          <ul>
            <li>Salary Slip</li>
            <li>Income Certificate</li>
            <li>Intimation u/s 143(1)</li>
          </ul>
        </div>
      </div>
    );
  };
  const getDocs = async () => {
    const docs2 = await api.getDocuments(
      "application",
      tokenData.applicationData.id,
      tokenData.token
    );
    dispatch(addTokenInfo(["docs", docs2.data]));
  };
  const delDoc = async (type, e) => {
    setDoc(e);
    e = validateFileName(e);
    let file;
    if (docs[incomeList[type]]) {
      file = docs[incomeList[type]];
    }
    if (e) {
      try {
        setUploading(true);
        showLoader(true);
        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", incomeList[type]);
        formData.append("fileType", e.type.split("/")[1]);
        if (file) {
          formData.append("id", file.id);
        }
        const result = await api.uploadDocument(
          "application",
          tokenData.applicationData.id,
          tokenData.token,
          formData
        );
        if (result?.statusCode == 200) {
          props.showModal("Your Document has been uploaded successfully!");
        }
        getDocs();
        setUploading(false);
        showLoader(false);
      } catch (error) {
        showLoader(false);
        alert("Sorry! Something went wrong, Please try again.");
        console.error("Error uploading document:", error);
        setUploading(false);
      } finally {
        setUploading(false);
      }
    }
  };
  const handleUpload = async (type, e) => {
    e = validateFileName(e);
    if (e) {
      try {
        setUploading(true);
        showLoader(true);
        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", type);
        formData.append("fileType", e.type.split("/")[1]);
        const result = await api.uploadDocument(
          "application",
          tokenData.applicationData.id,
          tokenData.token,
          formData
        );
        if (result?.statusCode == 200) {
          props.showModal("Your Document has been uploaded successfully!");
        }
        getDocs();
        setUploading(false);
        showLoader(false);
      } catch (error) {
        showLoader(false);
        alert("Sorry! Something went wrong, Please try again.");
        console.error("Error uploading document:", error);
        setUploading(false);
      } finally {
        setUploading(false);
      }
    }
  };

  function transformDate(dateStr) {
    // Split the date string into components
    const [day, month, year] = dateStr.split("-").map(Number);

    // Create a new Date object
    const date = new Date(year, month - 1, day);

    // Format the date to the required string format
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "long",
      timeZone: "Asia/Kolkata",
    };
    // console.log(
    //   "display normal",
    //   date.toLocaleString("en-US", options).replace(",", "")
    // );
    return date.toLocaleString("en-US").replace(",", "");
    // return date
  }

  useEffect(() => {
    // if(props.familyData === )
    // console.log("in ueh", props?.item?.relationShipType);

    let role = "";
    if (props?.item?.relationShipType === "Myself") {
      role = "My";
    } else {
      role = props?.item?.relationShipType;
    }
    // setMember(role);
    // if (props.item?.pan?.length === 10) {
    //   submitPan(props?.item?.pan);
    // }
  }, []);
  useEffect(() => {
    // console.log("pan updated", props.item?.pan, props.item?.pan?.length);
    let newList = incomeInfo.membersList.filter(
      (obj) =>
        obj.relationShipType !== props?.item?.relationShipType &&
        obj.pan.includes(props.item.pan)
    );
    if (newList?.length > 0) {
      isPan(true);
    }else if (props.item?.pan?.length === 10) {
      isPan(false);
    
      setTimeout(() => submitPan(props.item.pan), 50);
    }
    console.log("pan matching", newList);
    
  }, [props.item.pan]);
  useEffect(() => {
    if (props.item?.pan?.length === 10) {
      setTimeout(() => submitPan(props.item.pan), 100);
    }

    let isValid = props?.item?.dob instanceof Date && !isNaN(props?.item?.dob);
    if (props?.item?.dob && isValid) {
      let value = getValidDate(props.item.dob).split("-").reverse().join("-");

      setDate(value);
    }
  }, []);
  useEffect(() => {
    let newDate = isDate;
    const today1 = new Date();
    const givenDate = new Date(newDate); // Replace with the actual date to be checked
    const isFuture = givenDate > today1;

    const year = today1.getFullYear();
    const month = String(today1.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today1.getDate()).padStart(2, "0");
    let today2 = `${year}-${month}-${day}`;

    if (isFuture) {
      // value = "";
      newDate = today2;
      alert("Please select a date before today");
    }

    setDate(newDate || today2);
    if (newDate === "" && dateList[props?.item?.relationShipType]) {
      newDate = dateList[props?.item?.relationShipType];
    }

    // dispatch(addTokenInfo('dob', [props?.item?.relationShipType,newDate]))
    onClickhandler("dob", newDate);
    // dispatch(setDateList()
  }, [isDate]);

  useEffect(() => {
    console.log("status", status);
  }, [props.item]);
  console.log("in income", tokenData, status, incomeInfo);

  return (
    <div className="field-set earning-member" key={props.key}>
      <div className="set-title">
        {!props?.item?.relationShipType?.includes("Myself")
          ? props?.item?.relationShipType
          : "My"}
        {!props?.item?.relationShipType?.includes("Myself") && "'s"} Income
        Details
      </div>
      <div className="field-row">
        <div className="input-field-item">
          <Input
            placeholder={"Full Name(As per PAN Card)"}
            id="name"
            value={props.item?.firstName}
            onChange={(e) => onClickhandler("firstName", e)}

            // onChange={(e) => setPanNumber(e.target.value)}
          />
          {status?.incomeList?.rest?.includes("firstName") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
        <div className="input-field-item">
          <DropSelect
            value={props.item.occupation}
            onChange={(e) => onClickhandler("occupation", e)}
            title={"Occupation"}
            list={Occupations}
          />
          {status?.incomeList?.rest?.includes("occupation") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
      </div>{" "}
      <div className="field-row">
        <div className="field-validation-div input-field-item">
          <Input
            placeholder={"Mobile Number"}
            // id="mobile"
            id="password"
            type={"password"}
            value={props.item.mobile}
            onChange={(e) => onClickhandler("mobile", e)}

            // onChange={(e) => setPanNumber(e.target.value)}
          />

          {(status?.incomeList?.rest?.includes("mobile") ||
            props.item?.mobile?.length < 10) && (
            <p style={{ color: "red" }} className="set-sub-title">
              {status?.incomeList?.rest?.includes("mobile")
                ? props.item?.mobile === ""
                  ? "Required"
                  : props.item?.mobile?.length < 10
                  ? "Please enter a valid mobile number"
                  : ""
                : ""}
            </p>
          )}
        </div>
        <div className="input-field-item">
          <Input
            placeholder={"Annual Income"}
            id="number"
            inputType={"rupee"}
            value={props.item.income}
            onChange={(e) => onClickhandler("income", e)}

            // onChange={(e) => setPanNumber(e.target.value)}
          />
          {status?.incomeList?.rest?.includes("income") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
      </div>
      <div className="field-row">
        <div className="custom-input">
          <div className="custom-input-div">
            Date of Birth
            <input
              type="date"
              value={isDate || props?.item?.dob}
              onChange={(e) => setDate(e.target.value)}
              max={format(new Date(), "yyyy-MM-dd")}
              pattern="\d{2}/\d{2}/\d{4}"
              placeholder="DD/MM/YYYY"
            />
          </div>
          {status?.incomeList?.rest?.includes("dob") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
        <div className="field-validation-div">
          <Input
            placeholder={"PAN"}
            type={"password"}
            // mask={true}
            disabled={props.item.firstName === "" || props.item.dob === ""}
            id="password"
            value={props.item.pan}
            onChange={(e) => onClickhandler("pan", e.toUpperCase())}
          />
          {warning !== null && (
            <img
              className="verified-logo"
              src={warning ? verified : cross}
              alt={warning ? "verified" : "not verified"}
            />
          )}

          <p style={{ color: "red" }} className="set-sub-title">
            {props.item.pan === ""
              ? "Required"
              : panverified
              ? "Same PAN cannot be used"
              : props.item.pan !== "" && props.item?.pan?.length < 10
              ? "Please enter a valid Pan number, Full name, Date of Birth"
              : status?.incomeList?.rest?.includes("pan")
              ? "Invalid Details, Kindly submit the Full name, date of birth and PAN number as PAN card"
              : panErr}
          </p>
        </div>
      </div>
      <div
        className={`field-row upload ${
          docs && docs[incomeList[props?.item?.relationShipType]] && "doc-col"
        }`}
      >
        {docs && docs[incomeList[props?.item?.relationShipType]] ? (
          <div className="doc-item">
            <StaticItem
              onDelete={(e) => delDoc(props?.item?.relationShipType, e)}
              type={"doc"}
              isEditable={true}
              doc={docs[incomeList[props?.item?.relationShipType]]}
              title={"Proof of Income"}
              docUrl={
                docs[incomeList[props?.item?.relationShipType]]?.documentUrl
              }
              value={docs[incomeList[props?.item?.relationShipType]].name}
              size={Math.floor(
                docs[incomeList[props?.item?.relationShipType]].size / 1024
              )}
            />
          </div>
        ) : (
          // <div>{docs[`${member}Income`].name}</div>
          <div className="file-upload-container">
            <DocUpload
              title={"Proof of Income"}
              noTooltip={false}
              showErr={true}
              tooltipContent={toolTipData()}
              value={doc?.name ? doc : null}
              onChange={(e) =>
                handleUpload(incomeList[props?.item?.relationShipType], e)
              }
            />

            {/* <button
                  className="upload-button"
                  onClick={handleUpload}
                  disabled={uploading}
              >
                {uploading ? <span className="spinner"></span> : "Upload"}
              </button> */}
          </div>
        )}
        {docs &&
          status?.incomeList?.rest?.includes("doc") &&
          !docs[incomeList[props?.item?.relationShipType]] && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        {err && (
          <p className="set-sub-title">
            File size exceeds the maximum upload size limit.
          </p>
        )}
        <p>{errorMessage}</p>
      </div>
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default EarningMemberInfo;
